export type RegionCode = 'US' | 'UK' | 'MX' | 'FR' | 'DE';
export type CurrencyCode = 'USD' | 'EUR' | 'GBP' | 'MXN';

export const regions: RegionCode[] = ['US', 'UK', 'MX', 'FR', 'DE'];
export const flagSelectorRegions: RegionCode[] = ['UK', 'FR', 'DE'];

export interface Region {
  /**
   * Country identifier e.g. US or MX.
   */
  country: string;

  /**
   * Region identifier e.g. US, UK, FR or DE.
   */
  region: RegionCode;
}

export function isRegion(region: string | RegionCode): region is RegionCode {
  return regions.indexOf(region as never) !== -1;
}

export function isNorthAmerica(region: RegionCode): boolean {
  return region === 'US' || region === 'MX';
}

export function isEurope(region: RegionCode): boolean {
  return region === 'UK' || region === 'FR' || region === 'DE';
}

export function getDefaultRegion(): RegionCode {
  return regions[0];
}

/**
 * Returns the currency code for a given region.
 */
export function getCurrencyForRegion(region: RegionCode): CurrencyCode {
  switch (region) {
    case 'UK':
      return 'GBP';
    case 'FR':
    case 'DE':
      return 'EUR';
    case 'MX':
      return 'MXN';
    case 'US':
    default:
      return 'USD';
  }
}
